module.exports = __webpack_public_path__ + "assets/img/active.42f0e2ee.svg";